/**
 * Names the time zone a displayed time is expressed in, so an hour carried over from an archived
 * conversation is never ambiguous about whose clock it is.
 *
 * `O` is CLDR's *localized GMT* form and renders "GMT+2" identically in all five of our languages.
 * The abbreviation token (`zzz`) is deliberately avoided: CLDR only defines a short name for some
 * locale/zone pairs, so the same instant in Europe/Rome comes out "CEST" in Italian and Spanish,
 * "MESZ" in German, but "GMT+2" in English and "UTC+2" in French — the shape of the suffix would
 * change with the UI language. Abbreviations are ambiguous across countries too (CST is China,
 * Central US and Cuba). The offset is unambiguous, defined for every zone, and follows DST on its
 * own (GMT+1 in winter, GMT+2 in summer).
 *
 * UTC is the one exception, where the name reads better than a zero offset: "UTC", not "GMT+0".
 */
import { formatInTimeZone } from "date-fns-tz";

/** The viewer's own zone, as resolved by the browser. */
export function currentTimeZone(): string {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function zoneLabel(date: Date, timeZone: string = currentTimeZone()): string {
	return formatInTimeZone(date, timeZone, timeZone === "UTC" ? "zzz" : "O");
}
